var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home"},[_c('heroComp'),_c('metro-items'),_c('add-gateway-flow'),_c('plugins'),_c('customers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }